import { Injectable } from '@angular/core';
import * as Handlebars from 'handlebars';
import * as olControl from 'ol/control';
import * as olInteraction from 'ol/interaction';
import {asArray} from 'ol/color';
import * as olExtent from 'ol/extent';
import Feature from 'ol/Feature';
import * as geom from 'ol/geom';
import { transform } from 'ol/proj';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Circle from 'ol/style/Circle';
import Icon from 'ol/style/Icon';
import LineString from 'ol/geom/LineString';
import TileLayer from 'ol/layer/Tile';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import View from 'ol/View';
import Overlay from 'ol/Overlay';
import { SclMapConstantService } from './scl-map-constant.service';
import { SclUtilDateService} from 'formbird-sc-shared';
import { cloneDeep, chunk, nth, isString } from 'lodash';
import { SharedConstants } from '@formbird/types'
import { UtilHttpStatus } from '@formbird/shared';
import {sclHandlebars} from 'formbird-sc-shared';
import { isNumber } from 'lodash';
import { GEOJSON_TYPE, MapDrawType } from './map-library';

@Injectable({
  providedIn: 'root'
})
export class SclUtilMapService {

  constructor() { }
  private sclUtilDate = new SclUtilDateService();

  isContainAsset(asset, assets) {
    if (!assets) { return false; }
    for (let i = 0; i < assets.length; i++) {
      const ass = assets[i];
      if (ass.properties.linkAssets[0].documentId === asset.properties.linkAssets[0].documentId) { return true; }
    }
    return false;
  }
  isContainAssetWithType(asset, features) {
    if (!features) { return false; }
    for (let i = 0; i < features.length; i++) {
      const ass = features[i];
      if (ass.properties.linkAssets[0].documentId === asset.properties.linkAssets[0].documentId) { return true; }
    }
    return false;
  }
  containLayer(item, items) {
    if (!items) { return false; }
    for (let i = 0; i < items.length; i++) {
      const pos = items[i];
      if (pos === 'All' || pos === 'all') { return false; }
    }
    for (let i = 0; i < items.length; i++) {
      const pos = items[i];
      if (item === pos) { return true; }
    }
    return false;
  }
  removeItemFromMap(id, sourceVector) {
    const fea = sourceVector.getFeatureById(id);
    if (fea) {
      sourceVector.removeFeature(fea);
    }
  }
  getIdxAssetByType(features, type) {
    for (let i = 0; i < features.length; i++) {
      if (features[i].properties.type === type) {
        return i;
      }
    }
    return -1;
  }
  getQueryGeo(coor, coorNext, filter, geoJsonField, hasBoundingBox) {
    // if (!filter) { return null; }
    let res;
    let filterObj;
    if (typeof filter === 'string') {
      res = filter.replace(/'/g, '"');
      filterObj = JSON.parse(res);
    } else {
      filterObj = filter;
    }

    let command = '';
    if (geoJsonField) {
      command = geoJsonField + '.features.geometry';
    } else {
      command = 'features.geometry';
    }

    const feature = {};
    feature[command] = {
      shape: {
        type: 'envelope',
        coordinates: [coor, coorNext]
      },
      relation : 'intersects'
    };

    const geoshape = {
      geo_shape : feature
    };

    if (hasBoundingBox) {
      if (filterObj?.query?.bool?.filter) {
        filterObj.query.bool.filter.push(geoshape);
      } else if (filterObj?.query?.bool?.must) {
        filterObj.query.bool.must.push(geoshape);
      }
    }

    const query = JSON.stringify(filterObj);
    // logger.info("Query get avl event is " + query);
    return query;
  }
  getPointFeature(location , image, name, id, relatedAsset, color, layerDisplayOnly, tooltip, anchor, type, layerName) {
    const graphPoint = new Feature(new geom.Point(location));
    const properties: any = {
      icon : image,
      name,
      id
    };
    if (color) {properties.color = color; }
    if (tooltip) {properties.tooltip = tooltip; }
    if (layerDisplayOnly) {properties.layerDisplayOnly = layerDisplayOnly; }
    if (type) {properties.type = type; }
    if (anchor) {properties.anchor = anchor; }
    if (layerName) {properties.layerName = layerName; }
    if (relatedAsset) {
      for (const field in relatedAsset) {
        if (relatedAsset.hasOwnProperty(field)) {
          const value = relatedAsset[field];
          properties[field] = value;
        }
      }
    }
    const style = new Style({
      image: new Icon({
        anchor: [0.5, 0.5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        opacity: 1.0,
        scale: 1,
        src: image
      })
    });
    graphPoint.setProperties(properties);
    graphPoint.setStyle(style);
    return graphPoint;
  }
  getLineFeature(coordinates, id, name, EPSG, layer, relatedAsset, color, popup, layerName, layerDisplayOnly, lineDash) {
    const feature = this.parseToLine(coordinates, id, EPSG);
    const typeFeature = 'line';
    const lineWidth = layer.lineWidth !== undefined  ? layer.lineWidth : 4;
    const lineCap = layer.lineCap !== undefined ? layer.lineCap : 'round';
    const properties: any = {
      name: name,
      color: color,
      id: id,
      tooltip: popup,
      typeFeature: typeFeature,
      lineWidth: lineWidth,
      lineCap : lineCap
    };
    if (lineDash) { properties.lineDash = lineDash; }
    if (layerName) { properties.layerName = layerName; }
    if (layerDisplayOnly) { properties.layerDisplayOnly = layerDisplayOnly; }
    if (relatedAsset) {
      for (const field in relatedAsset) {
        if (relatedAsset.hasOwnProperty(field)) {
          properties[field] = relatedAsset[field];
        }
      }
    }
    feature.setProperties(properties);
    return feature;
  }
  parseRelatedField(source, relatedFields, primaryFields, secondaryFields) {
    const relatedAsset: any = {};
    if (primaryFields) {
      relatedAsset.primaryFields = {};
      for (const field in primaryFields) {
        if (primaryFields.hasOwnProperty(field)) {
          const fieldAsset = primaryFields[field];
          relatedAsset.primaryFields[field] = source[fieldAsset];
        }
      }
    }
    if (secondaryFields) {
      relatedAsset.secondaryFields = {};
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const fieldAsset = relatedFields[field];
          relatedAsset.secondaryFields[field] = source[fieldAsset];
        }
      }
    }
    if (relatedFields) {
      relatedAsset.mainFields = {};
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const fieldAsset = relatedFields[field];
          relatedAsset.mainFields[field] = source[fieldAsset];
        }
      }
    }
    return relatedAsset;
  }
  parseToLine(coor, id, toEPSG) {
    const array = [];
    for (let i = 0; i < coor.length; i++) {
      const coordinate = coor[i];
      const coordi = transform([parseFloat(coordinate[0]), parseFloat(coordinate[1])], SclMapConstantService.EPSG_4326, toEPSG);
      array.push(coordi);
    }
    const lineFeature = new Feature(new LineString(array));
    lineFeature.setId(id);
    return lineFeature;
  }
  queryLastEvent(imei) {
    const filter = {
      query: {
        bool: {
          filter: [
            {
              match: {
                'features.properties.imei': {
                  query: imei
                }
              }
            }
          ]
        }
      },
      /*"sort": [
          {
              "features.properties.eventDate": "desc"
          }
      ],*/
      size : 1
    };
    console.log('Query get last event is ' + JSON.stringify(filter));

    return filter;
  }
  parseAVLData(data) {
    const feature = data.features[0];
    const lat = feature.geometry.coordinates[0];
    const lon = feature.geometry.coordinates[1];

    const properties = feature.properties;

    const object: any = {};
    object.latitude = lat;
    object.longitude = lon;

    const currentDate = new Date(properties.eventDate);

    object.eventDate = currentDate;
    object.speedKPH = parseInt(properties.speedKPH, 10);

    let streetNo;
    let street;
    let town;
    let postcode;
    let state;
    let country;

    if (properties && properties.address) {
      streetNo = properties.address.streetNo;
      street = properties.address.street;
      town = properties.address.town;
      postcode = properties.address.postcode;
      state = properties.address.state;
      country = properties.address.country;
    }

    let address = '';
    if (streetNo) { address = streetNo; }
    if (street) { address += ', ' + street; }
    if (state) { address += ', ' + state; }
    if (town) { address += ', ' + town; }
    if (postcode) { address += ', ' + postcode; }
    if (country) { address += ', ' + country; }
    if (address) { object.address = address; }

    return object;
  }
  parseAVLData_New(item) {
    const feature = item.locationGeo.features[0];
    const properties = feature.properties;

    const currentDate = new Date();
    const newEventDate = new Date(item.eventDate);

    const obj: any = {};
    obj.id = item._id;
    obj.imei = item.imeis[0];
    obj.longitude = item.locationGeo.features[0].geometry.coordinates[0];
    obj.latitude = item.locationGeo.features[0].geometry.coordinates[1];
    obj.speedKPH = item.speedKPH;
    obj.heading = item.heading;
    obj.eventDate = item.eventDate;
    obj.address = ''; // TO DO : s? parse khi có json
    return obj;
  }
  checkAVLSpeed(beginning, speedKPH, heading, speedA, speedB, speedC, speedD, speedE) {
    let result = beginning;
    let exist = false;
    if (speedKPH <= speedA) {
      result += '_red_dot';
      exist = true;
    } else if (speedA < speedKPH && speedKPH <= speedB) {
      result += '_orange';
      if (SclMapConstantService.HEADING_THRESHOLD_H7 < heading || heading <= SclMapConstantService.HEADING_THRESHOLD_H0) {
        result += SclMapConstantService.AVL_SPEED_H0;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H0 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H1) {
        result += SclMapConstantService.AVL_SPEED_H1;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H1 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H2) {
        result += SclMapConstantService.AVL_SPEED_H2;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H2 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H3) {
        result += SclMapConstantService.AVL_SPEED_H3;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H3 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H4) {
        result += SclMapConstantService.AVL_SPEED_H4;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H4 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H5) {
        result += SclMapConstantService.AVL_SPEED_H5;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H5 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H6) {
        result += SclMapConstantService.AVL_SPEED_H6;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H6 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H7) {
        result += SclMapConstantService.AVL_SPEED_H7;
      }
      exist = true;
    } else if (speedB < speedKPH && speedKPH <= speedC) {
      result += '_green';
      if (SclMapConstantService.HEADING_THRESHOLD_H7 < heading || heading <= SclMapConstantService.HEADING_THRESHOLD_H0) {
        result += SclMapConstantService.AVL_SPEED_H0;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H0 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H1) {
        result += SclMapConstantService.AVL_SPEED_H1;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H1 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H2) {
        result += SclMapConstantService.AVL_SPEED_H2;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H2 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H3) {
        result += SclMapConstantService.AVL_SPEED_H3;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H3 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H4) {
        result += SclMapConstantService.AVL_SPEED_H4;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H4 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H5) {
        result += SclMapConstantService.AVL_SPEED_H5;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H5 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H6) {
        result += SclMapConstantService.AVL_SPEED_H6;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H6 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H7) {
        result += SclMapConstantService.AVL_SPEED_H7;
      }
      exist = true;
    } else if (speedC < speedKPH && speedKPH <= speedD) {
      result += '_black';
      if (SclMapConstantService.HEADING_THRESHOLD_H7 < heading || heading <= SclMapConstantService.HEADING_THRESHOLD_H0) {
        result += SclMapConstantService.AVL_SPEED_H0;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H0 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H1) {
        result += SclMapConstantService.AVL_SPEED_H1;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H1 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H2) {
        result += SclMapConstantService.AVL_SPEED_H2;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H2 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H3) {
        result += SclMapConstantService.AVL_SPEED_H3;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H3 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H4) {
        result += SclMapConstantService.AVL_SPEED_H4;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H4 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H5) {
        result += SclMapConstantService.AVL_SPEED_H5;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H5 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H6) {
        result += SclMapConstantService.AVL_SPEED_H6;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H6 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H7) {
        result += SclMapConstantService.AVL_SPEED_H7;
      }
      exist = true;
    } else if (speedD < speedKPH && speedKPH <= speedE) {
      result += '_yellow';
      if (SclMapConstantService.HEADING_THRESHOLD_H7 < heading || heading <= SclMapConstantService.HEADING_THRESHOLD_H0) {
        result += SclMapConstantService.AVL_SPEED_H0;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H0 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H1) {
        result += SclMapConstantService.AVL_SPEED_H1;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H1 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H2) {
        result += SclMapConstantService.AVL_SPEED_H2;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H2 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H3) {
        result += SclMapConstantService.AVL_SPEED_H3;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H3 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H4) {
        result += SclMapConstantService.AVL_SPEED_H4;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H4 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H5) {
        result += SclMapConstantService.AVL_SPEED_H5;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H5 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H6) {
        result += SclMapConstantService.AVL_SPEED_H6;
      } else if (SclMapConstantService.HEADING_THRESHOLD_H6 < heading && heading <= SclMapConstantService.HEADING_THRESHOLD_H7) {
        result += SclMapConstantService.AVL_SPEED_H7;
      }
      exist = true;
    }
    result += '.png';
    if (exist === false) {
      result = 'styles/images/pp/pin30_black.png';
    }
    return result;
  }
  parseAVLTracePoint(point, timeFormat, imei) {
    // let coor = transform([parseFloat(point.latitude),
    // parseFloat(point.longitude)], SclMapConstantService.EPSG_4326, SclMapConstantService.EPSG_3857);

    const coor = transform([parseFloat(point.longitude), parseFloat(point.latitude)], SclMapConstantService.EPSG_4326, SclMapConstantService.EPSG_3857);

    const imeiContent = '<div><bold>IMEI : </bold> ' + imei + '</div>';
    let address = '';
    if (typeof point.address !== 'undefined') {
        address = '<div><bold>Address : </bold> ' + point.address + '</div>';
    }

    const gps = '<div><bold>GPS : </bold> ' + point.latitude.toFixed(4) + '/' +
        point.longitude.toFixed(4) + '</div>';

    const eventDate = new Date(point.eventDate);

    const dateFormat = this.sclUtilDate.parseDate(eventDate, timeFormat);
    const dateContent = '<div><bold>Time : </bold> ' + dateFormat + '</div>';
    const speedContent = '<div><bold>Speed : </bold> ' + point.speedKPH + '</div>';
    const tooltip = imeiContent + address + gps + dateContent + speedContent;

    const propertiesData = {
        address: tooltip,
        icon: point.icon
    };

    const pointFeature = new Feature(new geom.Point(coor));
    pointFeature.setProperties(propertiesData);

    return pointFeature;
  }
  constructQueryVehicleData(imeis, doc) {
    const feature: any = {};
    feature.imei = imeis;

    const terms = {
      terms: feature
    };

    const match = {
      match: {
        appTags: {
          query: 'avlVehicle'
        }
      }
    };

    const filter = {
      query: {
        bool: {
          filter: [terms, match]
        }
      }
    };

    const query = JSON.stringify(filter);
    // logger.info("Query imeis from list : " + query);

    const options: any = {};
    // there is no need to set the pageSize to the default. It only needs to be set if
    // it is different to the default
    // options.pageSize = SharedConstants.DEFAULT_PAGE_SIZE;
    options.filter = query;
    options.document = doc;
    return options;
  }
  constructQueryGeoZones(filter, doc) {

    const res = filter.replace(/'/g, '"');
    const filterObj = JSON.parse(res);
    const query = JSON.stringify(filterObj);
    // logger.info("Query geozone from  : " + query);

    const options: any = {};
    // there is no need to set the pageSize to the default. It only needs to be set if
    // it is different to the default
    // options.pageSize = SharedConstants.DEFAULT_PAGE_SIZE;
    options.filter = query;
    options.document = doc;
    return options;
  }
  constructQueryDocument(docIds, doc) {
    const documentId: any = {};
    documentId.documentId = docIds;

    const terms = {
      terms: documentId
    };

    const filter = {
      query: {
        bool: {
          filter: [terms]
        }
      }
    };

    const query = JSON.stringify(filter);
    // logger.info("Query documentId from list : " + query);

    const options: any = {};
    // there is no need to set the pageSize to the default. It only needs to be set if
    // it is different to the default
    // options.pageSize = SharedConstants.DEFAULT_PAGE_SIZE;
    options.filter = query;
    options.document = doc;
    return options;
  }
  queryVehicleInfo(imei) {
    const filter = {
      query: {
        bool: {
          filter: [
            {
              match: {
                imei: {
                  query: imei
                }
              }
            }
          ]
        }
      }
    };
    const query = JSON.stringify(filter);
    // logger.info("The Query vehicle info is " + query);

    return query;
  }
  parseAVLQuery(date, imei, numOffSet) {
    const startDate = new Date(date);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setHours(startDate.getHours() + numOffSet);
    // logger.info("Start Date is " + startDate);

    const endDate = new Date(date);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate.setHours(endDate.getHours() + numOffSet);
    // logger.info("end Date is " + endDate);

    const format = 'YYYY-MM-DD HH:mm:ss';
    const startDateFormat = this.sclUtilDate.parseDate(startDate, format);
    const endDateFormat = this.sclUtilDate.parseDate(endDate, format);

    const filter = {
      query: {
        bool: {
          filter: [
            {
              match: {
                'features.properties.imei': {
                  query: imei
                }
              }
            },
            {
              range: {
                'features.properties.eventDate': {
                  gte: startDateFormat,
                  lte: endDateFormat,
                  format: 'yyyy-MM-dd HH:mm:ss'
                }
              }
            }
          ]
        }
      },
      sort: [
        {
          'features.properties.eventDate': 'asc'
        }
      ]
    };
    const query = JSON.stringify(filter);
    // logger.info("Query get list trace event is " + query);

    return query;
  }
  positionView(view, lng, lat, zoom, EPSG) {
    lat = typeof lat !== 'undefined' ? lat : 0;
    lng = typeof lng !== 'undefined' ? lng : 0;
    zoom = typeof zoom !== 'undefined' ? zoom : 2;
    EPSG = typeof EPSG !== 'undefined' ? EPSG : SclMapConstantService.EPSG_3857;
    view.setCenter(transform([lng, lat], SclMapConstantService.EPSG_4326, EPSG));
    view.setZoom(zoom);

    return view;
  }
  setView(lng, lat, zoom, EPSG, minResolution, maxResolution) {
    lat = typeof lat !== 'undefined' ? lat : 0;
    lng = typeof lng !== 'undefined' ? lng : 0;
    zoom = typeof zoom !== 'undefined' ? zoom : 2;
    EPSG = typeof EPSG !== 'undefined' ? EPSG : SclMapConstantService.EPSG_3857;
    let view;
    if (minResolution && maxResolution) {
      view = new View({
        projection: EPSG,
        center: transform([lng, lat], SclMapConstantService.EPSG_4326, EPSG),
        zoom,
        minResolution,
        maxResolution
      });
    } else {
      view = new View({
        projection: EPSG,
        center: transform([lng, lat], SclMapConstantService.EPSG_4326, EPSG),
        zoom,
        minZoom: 2
      });
    }
    return view;
  }
  createAddressQuery(geoJsonField) {
    const filter = {
      query: {
        bool: {
          filter: [
            {exists: {field: geoJsonField}},
            {term : {appTags : 'property'}}
          ]
        }
      }
    };
    console.log('The Query Address is ' + JSON.stringify(filter));

    return filter;
  }
  getDocument(result) {
    const prefix = '_source';
    let hold = result;
    if (result && prefix) {
      const split = prefix.split('.');
      for (let i = 0; i < split.length; i++) {
        if (split[i]) {
          if (hold[split[i]]) {
            hold = hold[split[i]];
          } else {
            hold = null;
            break;
          }
        } else {
          break;
        }
      }
    }

    return hold;
  }
  fit(ConfigService, sourceVector, view, map, maxZoomComponent) {
    let maxZoom = 15;
    if (maxZoomComponent) {
      maxZoom = maxZoomComponent;
    } else {
      if (ConfigService.clientConfig().maxZoomLevel) {
        maxZoom = ConfigService.clientConfig().maxZoomLevel;
      }
    }

    const featuresExtent = olExtent.createEmpty();

    sourceVector.getFeatures().forEach(function(feature) {
      olExtent.extend(featuresExtent, feature.getGeometry().getExtent());
    });

    view.fit(featuresExtent, map.getSize(), {maxZoom});
  }
  initializeMap(ConfigService, controls, target, view, interactions, disableMouseWheel, mapLayers, multiLayers) {
    let sourceXYZ = [];

    if (multiLayers && multiLayers.length > 0) {
      sourceXYZ = multiLayers;
    } else {
      if (mapLayers) {
        sourceXYZ.push(mapLayers);
      } else {
        const optionOSM = {
          url: ConfigService.clientConfig().openLayers.tileServer.url,
          crossOrigin: ConfigService.clientConfig().openLayers.tileServer.crossOrigin,
          wrapDateLine: false, // not support 6.15.1
          wrapX: false,
          noWrap: true // not support 6.15.1
        };
        const tile = new TileLayer({
          source: new OSM(optionOSM)
        });
        sourceXYZ.push(tile);
      }
    }

    let mouseWheel = true;
    if (disableMouseWheel) {
      mouseWheel = false;
    }
    const map = new Map({
      controls: olControl.defaults().extend([
        new olControl.FullScreen()
      ]),
      interactions: olInteraction.defaults({mouseWheelZoom: mouseWheel}),
      layers: sourceXYZ,
      target,
      view
    });

    if (controls.length) {
      for (let i = 0; i < controls.length; i++) {
        map.addControl(controls[i]);
      }
    }

    if (interactions.length) {
      for (let i = 0; i < interactions.length; i++) {
        map.addInteraction(interactions[i]);
      }
    }

    return map;
  }
  initializeMapDefault(controls, target, view, interactions, disableMouseWheel, mapLayers, multiLayers) {
    let sourceXYZ = [];

    if (multiLayers && multiLayers.length > 0) {
      sourceXYZ = multiLayers;
    } else {
      if (mapLayers) {
        sourceXYZ.push(mapLayers);
      } else {
        const optionOSM = {
          wrapDateLine: false, // not support 6.15.1
          wrapX: false,
          noWrap: true // not support 6.15.1
        };
        const tile = new TileLayer({
          source: new OSM(optionOSM)
        });
        sourceXYZ.push(tile);
      }
    }

    let mouseWheel = true;
    if (disableMouseWheel) {
      mouseWheel = false;
    }
    const map = new Map({
      controls: olControl.defaults().extend([
        new olControl.FullScreen()
      ]),
      interactions: olInteraction.defaults({mouseWheelZoom: mouseWheel}),
      layers: sourceXYZ,
      target,
      view
    });

    if (controls.length) {
      for (let i = 0; i < controls.length; i++) {
        map.addControl(controls[i]);
      }
    }

    if (interactions.length) {
      for (let i = 0; i < interactions.length; i++) {
        map.addInteraction(interactions[i]);
      }
    }

    return map;
  }
  getPointStyle(color, icon, imageAnchor, zIndex) {
    let zIn = 0;
    if (zIndex) {zIn = zIndex; }
    let pointColor = 'green';
    if (color) {pointColor = color; }
    let image: any = new Circle({
      radius: 7,
      fill: new Fill({
        color: '#ffcc33'
      })
    });
    if (icon) {
      let anchor = [0.5, 0.5];
      if (imageAnchor) { anchor = imageAnchor; }
      image = new Icon(({
        src: icon,
        anchor
      }));
    }
    const style = new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new Stroke({
        color: pointColor,
        width: 2
      }),
      zIndex: zIn,
      image
    });
    return style;
  }
  getLineStyle(color, properties) {
    let lineColor = 'blue';
    if (color) { lineColor = color; }

    const style = new Style({
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33'
        })
      })
    });

    const stroke = new Stroke({
      color: lineColor,
      width: 2
    });
    if (properties) {
      if (properties.lineWidth) {stroke.setWidth(properties.lineWidth); }
      if (properties.lineDash) {stroke.setLineDash(properties.lineDash); }
      if (properties.lineCap) {stroke.setLineCap(properties.lineCap); }
    }
    style.setStroke(stroke);
    let fillColor = 'rgba(255, 255, 255, 0.2)';
    if (properties && properties.fillColor) {
      // fillColor = properties.fillColor;
      color = asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) {color[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = color;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);
    return style;
  }
  getWrapLon(value) {
    const worlds = Math.floor((value + 180) / 360);
    return value - (worlds * 360);
  }
  getGeocodeAddress(url, key, text, field) {
    let link = url + text;
    if (key) { link = link + '&key=' + key; }
    if (field) {
      if (field.country) {
        link = link + '&country=' + field.country;
      }
      if (field.language) {
        link = link + '&lang=' + field.language;
      }
    }
    return link;
  }
  getGoogleAddress(text, key) {
    // https://maps.googleapis.com/maps/api/place/textsearch/json?query=123+main+street&key=YOUR_API_KEY
    // let link = "https://maps.googleapis.com/maps/api/place/textsearch/json?query=" + text + "&key=" + key;
    const link = 'https://maps.googleapis.com/maps/api/place/autocomplete/json?query=' + text + '&key=' + key;
    return link;
  }
  getGeocodeCoordinate(url, lat, lon, field, key) {
    let link = url + '?lat=' + lat + '&lon=' + lon + '&key=' + key + '&count=1';
    if (field) {
      if (field.country) {
        link = link + '&country=' + field.country;
      }
      if (field.language) {
        link = link + '&lang=' + field.language;
      }
    }
    return link;
  }
  getAllCoordinates(feature) {
    const coords = [];
    if (feature.geometry.type === 'Polygon') {
      let k;
      for (k = 0; k < feature.geometry.coordinates[0].length; k++) {
        coords.push(feature.geometry.coordinates[0][k]);
      }
    } else if (feature.geometry.type === 'LineString') {
      let j;
      for (j = 0; j < feature.geometry.coordinates.length; j++) {
        coords.push(feature.geometry.coordinates[j]);
      }
    } else if (feature.geometry.type === 'Point') {
      if (feature.geometry.coordinates.length > 0) {
        coords.push(feature.geometry.coordinates);
      }
    } else if (feature.geometry.type === 'MultiPolygon') {
      let k;
      for (k = 0; k < feature.geometry.coordinates.length; k++) {     // loop through each multipolygon
        const pol = feature.geometry.coordinates[k];
        let k1;
        for (k1 = 0; k1 < pol.length; k1++) {           // loop throuch each polygon in this multipolygon
          const pol1 = pol[k1];
          if (pol1.length >= 3) {          // a valid polygon should have >= 3 coordinates
            let k2;
            for (k2 = 0; k2 < pol1.length; k2++) {      // loop throuch each coordinates in this polygon
              coords.push(pol1[k2]);
            }
          }
        }
      }
    } else if (feature.geometry.type === 'MultiLineString') {
      let k;
      for (k = 0; k < feature.geometry.coordinates.length; k++) {     // loop through each LineString
        const pol = feature.geometry.coordinates[k];
        if (pol.length >= 2) {
          let k1;
          for (k1 = 0; k1 < pol.length; k1++) {           // loop throuch each coordinates in this LineString
            coords.push(pol[k1]);
          }
        }
      }
    } else if (feature.geometry.type === 'MultiPoint') {
      let k;
      for (k = 0; k < feature.geometry.coordinates.length; k++) {     // loop through each LineString
        coords.push(feature.geometry.coordinates[k]);
      }
    }
    return coords;
  }
  isValidFeature(f) {
    if (f.geometry.type === 'LineString') {
      if (f.geometry.coordinates.length >= 2) {
        return true;
      }
    } else if (f.geometry.type === 'Polygon') {
      if (f.geometry.coordinates.length >= 1 && f.geometry.coordinates[0].length >= 3) {
        return true;
      }
    } else if (f.geometry.type === 'Point' && f.geometry.coordinates.length > 1) {
      return true;
    } else if (f.geometry.type === 'MultiPoint' && f.geometry.coordinates.length > 1) {
      return true;
    } else if (f.geometry.type === 'MultiLineString') {
      let k;
      for (k = 0; k < f.geometry.coordinates.length; k++) {     // loop through each LineString
        const pol = f.geometry.coordinates[k];
        if (pol.length < 2) {
          return false;
        }
      }
      return true;
    } else if (f.geometry.type === 'MultiPolygon') {
      let k;
      for (k = 0; k < f.geometry.coordinates.length; k++) {     // loop through each multipolygon
        const pol = f.geometry.coordinates[k];
        let k1;
        for (k1 = 0; k1 < pol.length; k1++) {           // loop throuch each polygon in this multipolygon
          const pol1 = pol[k1];
          if (pol1.length < 3) {          // a valid polygon should have >= 3 coordinates
            return false;
          }
        }
      }

      return true;
    }
    return false;
  }
  transformEPSG(long, lat, from, to) {
    const location = transform([parseFloat(long), parseFloat(lat)], from, to);
    return location;
  }
  transformCoordinate(coordinate, from, to) {
    const location = transform(coordinate, from, to);
    return location;
  }
  
  // Deprecated - use sclHandlebars.processHandlebars()
  parseHandlerBar(stringHandlerbars, data) {
    if (stringHandlerbars == null) { return ''; }

    const template = Handlebars.compile(stringHandlerbars);
    const result = template(data);
    return result;
  }
  preSuffixNumbers(pre, suff, num) {
    let fixedNum;
    fixedNum = (pre != null ? pre : '') + (num != null ? num : '') + (suff != null ? suff : '');
    if (fixedNum != null && fixedNum.length > 0) {
      return fixedNum;
    } else {
      return null;
    }
  }
  parseAddress(address) {
    const sugg: any = {};
    sugg.street = address.addressLine;

    const res = address.pos[0].split(',');
    sugg.coordinates = {},
      sugg.coordinates.latitude = res[0];
    sugg.coordinates.longitude = res[1];

    sugg.address = {},
      sugg.address.unitNo = this.preSuffixNumbers(address.unitNumberPrefix, address.unitNumberSuffix, address.unitNumber);
    sugg.address.street_number = this.preSuffixNumbers(address.thoroughfareNumberFromPrefix,
      address.thoroughfareNumberFromSuffix, address.thoroughfareNumberFrom);
    sugg.address.street_name = '';
    if (address.thoroughfareName) { sugg.address.street_name = address.thoroughfareName; }
    if (address.thoroughfareTrailingType) { sugg.address.street_name += ' ' + address.thoroughfareTrailingType; }
    sugg.address.locality = address.locality;
    sugg.address.postal_code = address.postcode;
    if (!address.country) { sugg.address.country = 'Australia'; }
    sugg.address.admin_1 = address.state;

    return sugg;
  }
  createBorderMandatory(doc) {
    // let mandatoryF;

    // if( typeof scope.componentDefinition.mandatoryFields === 'undefined' || scope.componentDefinition.mandatoryFields === null ){
    //     mandatoryF = [ "primaryAsset" ];
    // }
    // else {
    //     mandatoryF = scope.componentDefinition.mandatoryFields;
    // }
    // angular.forEach(mandatoryF, function(value, key) {
    //     //include mandatory=true|false in condition of function fnAddMandatoryBorder
    //     if( typeof scope.componentDefinition.mandatory === 'undefined' || scope.componentDefinition.mandatory === null ){
    //         scope.componentDefinition.mandatory=false;
    //     }
    //     if(scope.componentDefinition.mandatory){
    //         let target = "";
    //         if(angular.equals(value,"unitNo")){
    //             target =  angular.element(element).find("#"+'unitNumD')[0];
    //         } else if(angular.equals(value,"streetNo")){
    //             target =  angular.element(element).find("#"+'streetD')[0];
    //         } else if(angular.equals(value,"street")){
    //             target =  angular.element(element).find("#"+'streetNameD')[0];
    //         } else if(angular.equals(value,"suburb")){
    //             target =  angular.element(element).find("#"+'subUrbTownD')[0];
    //         } else if(angular.equals(value,"postcode")){
    //             target =  angular.element(element).find("#"+'postcodeD')[0];
    //         } else if(angular.equals(value,"country")){
    //             target =  angular.element(element).find("#"+'countryD')[0];
    //         } else if(angular.equals(value,"state")){
    //             target =  angular.element(element).find("#"+'stateD')[0];
    //         } else if(angular.equals(value,"locationDescription")){
    //             target =  angular.element(element).find("#"+'descriptionAddressD')[0];
    //         } else if(angular.equals(value,"coordinates")){
    //             target =  angular.element(element).find("#"+'latitudeD')[0];
    //             $(target).css('border','solid red 1px');
    //             target =  angular.element(element).find("#"+'longitudeD')[0];
    //         } else if(angular.equals(value,"primaryAsset")){
    //             target =  angular.element(element).find("#"+'primaryAsset')[0];
    //         } else if(angular.equals(value,"secondaryAsset")){
    //             target =  angular.element(element).find("#"+'secondaryAsset')[0];
    //         }
    //         $(target).css('border','solid red 1px');
    //     }
    // });
    // scope.change();
  }
  parseQuery(filter, geojsonField) {
    let filterObj;
    if (typeof filter === 'string') {
      const res = filter.replace(/'/g, '"');
      //// logger.info("Handlebars parsing before "+res);
      // res = scope.sclUtilMap.parseCellTemplate(res);
      //// logger.info("Handlebars parsing after"+res);

      filterObj = JSON.parse(res);
    } else {
      filterObj = filter;
    }
    if (geojsonField) {
      if (filterObj.query.bool.filter) {
        const term = {
          term: {}
        };
        const value = geojsonField + '.type';
        term.term[value] = GEOJSON_TYPE.FEATURE_COLLECTION;
        filterObj.query.bool.filter.push(term);
      } else if (filterObj.query.bool.must) {
        const exist = {
          match: {}
        };
        const value = geojsonField + '.type';
        exist.match[value] = {
          query: GEOJSON_TYPE.FEATURE_COLLECTION
        },
          filterObj.query.bool.must.push(exist);
      }
    }
    const query = JSON.stringify(filterObj);
    // logger.info("The query is " + query);
    return filterObj;
  }
  processVicmapSearch(url, scope) {
    // jQuery.getJSON(url, null, function(addressResponse) {
    //     let result = (addressResponse.requestResult.result);
    //     if(result){
    //         let results = [];
    //         for (let k = 0; k < result.length; k++) {
    //             let r = result[k];
    //             let p = r.address;
    //             for (let f = 0; f < p.length; f++) {
    //                 let predict = p[f];
    //                 results.push(parseAddress(predict));
    //             }
    //         }
    //         $timeout(function () {
    //             scope.results.data = results;
    //         });
    //     }
    // });
    // return scope;
  }
  search(scope, text, mapField, psmaAutoCompleteURL, psmaKey) {
    // let newText = text.trim();
    // if(newText === scope.preText) return;

    // if(text !== undefined) {
    //     scope.results.data = [];
    //     scope.preText = text;
    //     scope.inputText = text;
    //     if(scope.geocoderDefaultState) text = text + ", " + scope.geocoderDefaultState;
    //     if(scope.geocoderDefaultCountry) text = text + ", " + scope.geocoderDefaultCountry;
    //     //logger.info("Checking for Address : " + text);
    //     let link = this.getGeocodeAddress(scope.autocompleteURL, scope.apiKey, text, mapField);
    //     if(scope.geocodeName === "vicmap"){
    //         link = this.getGeocodeAddress(scope.autocompleteURL, "", text);
    //         this.processVicmapSearch(link, scope);
    //     }
    //     else if(scope.geocodeName === "psma"){
    //         link = scope.psmaAutoCompleteURL + text;
    //         let apiKey = scope.psmaKey;
    //         //link = autocompleteURL + text;
    //         $http.get(link, { headers: {'API-Key': apiKey} }).then(function(data_result){
    //             if(data_result.statusText == "OK"){
    //                 let suggestions = data_result.data.suggest;
    //                 let results = [];
    //                 for(let i = 0; i < suggestions.length; i++){
    //                     let sugg = {},
    //                     sugg.street = suggestions[i].address;//show in UI
    //                     sugg.id = suggestions[i].id;
    //                     results.push(sugg);
    //                 }
    //             }
    //             scope.results.data = results;
    //         });
    //     }else if(scope.geocodeName === "psmafarm"){
    //         link = scope.psmafarmAutoCompleteURL + text;
    //         $http.get(link, { headers: {'API-Key': scope.psmafarmKey} }).then(function(data_result){
    //             if(data_result.statusText == "OK"){
    //                 let suggestions = data_result.data.suggest;
    //                 let results = [];
    //                 for(let i = 0; i < suggestions.length; i++){
    //                     let sugg = {},
    //                     sugg.street = suggestions[i].address;//show in UI
    //                     sugg.id = suggestions[i].id;
    //                     results.push(sugg);
    //                 }
    //             }
    //             scope.results.data = results;
    //         });
    //     }
    //     else {
    //         scope.lastLink = link;
    //         $http.get(link).then(function (data_result) {
    //             let data = data_result.data;
    //             if (data && data.geocoding_results && data.geocoding_results.STATUS.status === "SUCCESS") {
    //                 let suggestions = data.geocoding_results.RESULTS;
    //                 let results = [];
    //                 // check if the results are from the latest query not an earlier one that is out of sync
    //                 if ( data_result.config.url !== scope.lastLink ) {
    //                     //logger.info("Search results are from earlier query, "+data_result.config.url+" ignore this set");
    //                     return;
    //                 }
    //                 for (let i = 0; i < suggestions.length; i++) {
    //                     let predict = suggestions[i];
    //                     let sugg = {},
    //                     sugg.street = predict.formatted_address;
    //                     sugg.address = predict.ADDRESS;
    //                     sugg.coordinates = predict.COORDINATES;
    //                     results.push(sugg);
    //                 }
    //                 scope.results.data = results;
    //             }
    //         }).catch(function(error) {
    //             logger.error("Error : " + error);
    //         });
    //     }
    // }

    // return scope;
  }
  fillGoogleAddress(data, streetData) {
    for (let i = 0; i < data.address_components.length; i++) {
      const addressType = data.address_components[i].types[0];
      const val = data.address_components[i].long_name;
      if (addressType === 'subpremise') {
        streetData.properties.unitNo = val;
      } else if (addressType === 'street_number') {
        streetData.properties.streetNo = val;
      } else if (addressType === 'route') {
        streetData.properties.street = val;
      } else if (addressType === 'administrative_area_level_1') {
        streetData.properties.state = val;
      } else if (addressType === 'locality') {
        streetData.properties.suburb = val;
      } else if (addressType === 'postal_code') {
        streetData.properties.postcode = val;
      } else if (addressType === 'country') {
        streetData.properties.country = val;
      }
    }
    if (data.geometry && data.geometry.location) {
      streetData = this.checkStreetGeometry(streetData);
      if (!isNaN(data.geometry.location.lng)) {
        streetData.geometry.coordinates[0] = data.geometry.location.lng;
      } else {
        streetData.geometry.coordinates[0] = data.geometry.location.lng();
      }

      if (!isNaN(data.geometry.location.lat)) {
        streetData.geometry.coordinates[1] = data.geometry.location.lat;
      } else {
        streetData.geometry.coordinates[1] = data.geometry.location.lat();
      }
    }
    return streetData;
  }
  checkStreetGeometry(streetData) {
    if (!streetData.geometry) {
      const geometry = {
        type: 'Point',
        coordinates: []
      };
      streetData.geometry = geometry;
    }
    return streetData;
  }
  checkStreetGeometryComponent(streetDataComp, keyName) {
    if (streetDataComp && streetDataComp.streetData && streetDataComp.streetData[keyName] && !streetDataComp.streetData[keyName].geometry) {
      const geometry = {
          type: MapDrawType.POINT,
          coordinates: []
      };
      const st = streetDataComp.streetData[keyName];
      if (st) {
          st.geometry = geometry;
          streetDataComp.streetDataStr = JSON.stringify(st);
      }
    }
  }

  setTooltipPosition(scope, pixel) {
    // let result = {},
    // let featureLeftPos = pixel[0];
    // let featureTopPos = pixel[1];

    // result.left = featureLeftPos + 'px';
    // result.top = featureTopPos + 'px';

    // // set the tooltip position
    // let tooltipHorizontalPosition;
    // let tooltipVerticalPosition;

    // if (featureLeftPos < scope.mapCenter.x) {
    //     tooltipHorizontalPosition = "left";
    //     //featureLeftPos -= 10;
    // } else {
    //     tooltipHorizontalPosition = "right";
    //     //featureLeftPos += 25;
    // }

    // if (featureTopPos < scope.mapCenter.y) {
    //     tooltipVerticalPosition = "bottom";
    //     //featureTopPos += 10;
    // } else {
    //     tooltipVerticalPosition = "top";
    //     //featureTopPos -= 10;
    // }

    // result.tooltipPosition = tooltipVerticalPosition + "-" + tooltipHorizontalPosition;

    // //scope.infoPosition.left = featureLeftPos + 'px';
    // //scope.infoPosition.top = featureTopPos + 'px';

    // return result;
  }
  streetDataRemoveEmpty(street) {
    if (street.properties) {
      if (street.properties.hasOwnProperty('unitNo') && (street.properties.unitNo === null
        || street.properties.unitNo.trim().length === 0) ) {
         delete street.properties.unitNo;
       }
       if (street.properties.hasOwnProperty('streetNo') && (street.properties.streetNo === null
         || street.properties.streetNo.trim().length === 0) ) {
         delete street.properties.streetNo;
       }
       if (street.properties.hasOwnProperty('street') && (street.properties.street === null
       || street.properties.street.trim().length === 0) ) {
         delete street.properties.street;
       }
       if (street.properties.hasOwnProperty('suburb') && (street.properties.suburb === null
       || street.properties.suburb.trim().length === 0) ) {
         delete street.properties.suburb;
       }
       if (street.properties.hasOwnProperty('postcode') && (street.properties.postcode === null
       || street.properties.postcode.trim().length === 0) ) {
         delete street.properties.postcode;
       }
       if (street.properties.hasOwnProperty('locationDescription') && (street.properties.locationDescription === null
       || street.properties.locationDescription.trim().length === 0) ) {
         delete street.properties.locationDescription;
       }
       if (street.properties.hasOwnProperty('country') && (street.properties.country === null
       || street.properties.country.trim().length === 0) ) {
         delete street.properties.country;
       }
       if (street.properties.hasOwnProperty('iconImage') && (street.properties.iconImage === null
       || street.properties.iconImage.trim().length === 0) ) {
         delete street.properties.iconImage;
       }
       if (street.properties.hasOwnProperty('iconSize') && (street.properties.iconSize === null
       || street.properties.iconSize.trim().length === 0) ) {
         delete street.properties.iconSize;
       }
       if (street.properties.hasOwnProperty('state') && (street.properties.state === null
         || street.properties.state.trim().length === 0) ) {
           delete street.properties.state;
       }
    }
    
  }
  isValidPoint(obj) {
    return obj.geometry 
        && obj.geometry.type === MapDrawType.POINT 
        && Array.isArray(obj.geometry.coordinates) 
        && obj.geometry.coordinates.length === 2
        && obj.geometry.coordinates.every(coord => 
            typeof coord === 'number' && 
            !isNaN(coord) && 
            isFinite(coord)
        );
  }
  createOverlay(container) {
    return new Overlay(({
      element: container,
      autoPan: true,
      positioning: 'center-center',
      autoPanAnimation: {
        duration: 250
      }
    }));
  }
  styleFunction(feature, resolution) {
    const p = feature.getProperties();
    const geometry = feature.getGeometry();
    if (geometry && geometry.getType() === 'Point') {
      let icon = '';
      if (p && p.icon) {
          icon = p.icon;
      }

      const stylePoint = [new Style({
          image: new Icon(({
              src: icon,
              anchor: [0.5, 1]
          }))
      })];
      return stylePoint;
    }
    const styles = [new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new Stroke({
            color: 'red',
            width: 2
        }),
        image: new Circle({
            radius: 7,
            fill: new Fill({
                color: '#ffcc33'
            })
        })
    })];
    if (p && p.displayArrorHeads) {
      geometry.forEachSegment( (start, end) => {
          const dx = end[0] - start[0];
          const dy = end[1] - start[1];
          const rotation = Math.atan2(dy, dx);
          // arrows
          styles.push(new Style({
            geometry: new geom.Point(end),
            image: new Icon({
              src: SclMapConstantService.MAP_MARKER_ARROW,
              anchor: [0.75, 0.5],
              rotateWithView: false,
              rotation: -rotation
            })
          }));
      });
    }

    return styles;
  }
  parseLineString(coor, coor1, nextCoor, nextCoor1) {
    return new Feature(new geom.LineString([[coor, coor1], [nextCoor, nextCoor1]]));
  }

  dexieSearchFunction(filterFunc, pageNumber?, numberPerPage?) {


    return {
      dexieSearchFunction: function(db, callbackFunc) {

        try {
          const fun = eval('(' + filterFunc + ')');
          if (fun) {
            fun(db, function(err, filterDocs) {
              if (err) {
                callbackFunc(err);
              } else {
                let docs = [];
                if (filterDocs && filterDocs.length > 0) {
                  const size = numberPerPage || SharedConstants.DEFAULT_PAGE_SIZE;
                  const page = pageNumber || SharedConstants.DEFAULT_PAGE;
                  const docsArray = chunk(filterDocs, size);
                  docs = nth(docsArray, page);
                }


                let results;
                results = {};

                results.total = filterDocs.length;
                results.statusCode = UtilHttpStatus.OK;
                results.data = docs;
                results.searchProvider = 'dexie';
                callbackFunc(null, results);
              }
            });
          }

        } catch (err) {
          console.log(err);
          callbackFunc(err);
        }
      }
    };

  }
  calculateRotate(bearing, initialImageDirection, initialImageWheelDirection) {
    let calculateRotation = false;
    let calculateFlip = false;
    let rotation = 0;
    let isFlip = false;

    if (typeof(initialImageWheelDirection) == 'number' && (initialImageWheelDirection > 0 && initialImageWheelDirection <= 360)) {
      // we have wheels so may need to flip
      calculateFlip = true;
    }
    if (typeof(initialImageDirection) == 'number' && (initialImageDirection > 0 && initialImageDirection <= 360)) {
      // need to calculate rotation
      calculateRotation = true;
    }

    if (typeof(bearing) == 'number' && (bearing >= 0 && bearing <= 360)) {
      // need to calculate rotation
      calculateRotation = true;
    } else {
        // need to calculate rotation
      calculateRotation = false;
    }
    if (calculateRotation) {
      // calculate the rotation from the bearing and the initialImage Direction
      rotation = bearing - initialImageDirection;
      // normalise rotation to be between 0 and 360, we need a modulo so we loose the sign of the negative rotations so
      rotation = ((rotation % 360) + 360) % 360;

      if (calculateFlip) {
          // now calculate the flip if we need one
          const wheelRotation = initialImageWheelDirection - rotation;
          if (wheelRotation < 90 || wheelRotation > 270) {
            isFlip = true;
          }
      }

    }

    return {rotation, isFlip};
  }

  processHandlebarsOnVisualItem(componentDefinition, contextParams, value, field, handlebarsContext, returnType, handlebarsOptions) {

    let result;
    if (field) {
      switch (returnType) {
        case 'int':
          return sclHandlebars.processIntHandlebars(field, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        case 'float':
          return sclHandlebars.processFloatHandlebars(field, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        case 'boolean':
          return sclHandlebars.processBooleanHandlebars(field, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        case 'array':
          return sclHandlebars.processArrayHandlebars(field, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        default:
          return sclHandlebars.processHandlebars(field, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
      }
    } else if(value) {
      switch (returnType) {
        case 'int':
          return sclHandlebars.processIntHandlebars(value, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        case 'float':
          return sclHandlebars.processFloatHandlebars(value, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        case 'boolean':
          return sclHandlebars.processBooleanHandlebars(value, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        case 'array':
          return sclHandlebars.processArrayHandlebars(value, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
        default:
          return sclHandlebars.processHandlebars(value, handlebarsContext, null
            , componentDefinition.handlebarsHelpers, contextParams, handlebarsOptions);
      }
    }

    return result;
  }

  processHandlebarsOnLabel(componentDefinition, contextParams, label, handlebarsContext, layer, layerIndex, idCache) {
    label.labelText = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelText, layer.labelTextHandlebars, handlebarsContext, null, null);

    label.labelColor = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelColor, layer.labelColorHandlebars, handlebarsContext, null, null);

    label.labelOutlineColor = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelOutlineColor, layer.labelOutlineColorHandlebars, handlebarsContext, null, null);

    label.labelOutlineWidth = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelOutlineWidth, layer.labelOutlineWidthHandlebarsRemoveElastic, handlebarsContext, 'int', null);

    label.labelFont = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelFont, layer.labelFontHandlebars, handlebarsContext, null, null);

    label.labelFontSize = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelFontSize, layer.labelFontSizeHandlebars, handlebarsContext, 'int', null);

    label.labelTextAlign = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelTextAlign, layer.labelTextAlignHandlebars, handlebarsContext, null, null);

    label.labelTextBaseline = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelTextBaseline, layer.labelTextBaselineHandlebars, handlebarsContext, null, null);

    label.labelOffsetX = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelOffsetX, layer.labelOffsetXHandlebars, handlebarsContext, 'int', null);

    label.labelOffsetY = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelOffsetY, layer.labelOffsetYHandlebars, handlebarsContext, 'int', null);

    label.labelPlacement = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelPlacement, layer.labelPlacementHandlebars, handlebarsContext, null, null);

    label.labelMaxAngle = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelMaxAngle, layer.labelMaxAngleHandlebars, handlebarsContext, 'float', null);

    label.labelOverflow = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelOverflow, layer.labelOverflowHandlebars, handlebarsContext, 'boolean', null);

    label.labelRotationWithView = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelRotationWithView, layer.labelRotationWithViewHandlebars, handlebarsContext, 'boolean', null);

    label.labelRotation = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelRotation, layer.labelRotationHandlebars, handlebarsContext, 'int', null);

    label.labelPadding = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelPadding, layer.labelPaddingHandlebars, handlebarsContext, 'array', null);

    label.labelFontWeight = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelFontWeight, layer.labelFontWeightHandlebars, handlebarsContext, null, null);

    label.labelDisplayZoom = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       label.labelDisplayZoom, layer.labelDisplayZoomHandlebars, handlebarsContext, 'int', null);

    return label;
  }

  processHandlebarsOnLayer(componentDefinition, contextParams, layerClone, handlebarsContext, layer, layerIndex) {
    layerClone.lineCap = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       layer.lineCap, layer.lineCapHandlebars, handlebarsContext, null, null);
    if (!layerClone.lineCap && layer.lineCap) { layerClone.lineCap = layer.lineCap; }

    layerClone.lineWidth = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       layer.lineWidth, layer.lineWidthHandlebars, handlebarsContext, 'int', null);
    if (!layerClone.lineWidth && layer.lineWidth) { layerClone.lineWidth = layer.lineWidth; }

    layerClone.lineDash = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       layer.lineDash, layer.lineDashHandlebars, handlebarsContext, 'array', null);
    if (!layerClone.lineDash && layer.lineDash) { layerClone.lineDash = layer.lineDash; }

    layerClone.fill = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       layer.fill, layer.fillHandlebars, handlebarsContext, null, null);
    if (!layerClone.fill && layer.fill) { layerClone.fill = layer.fill; }

    layerClone.fillOpacity = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
       layer.fillOpacity, layer.fillOpacityHandlebars, handlebarsContext, 'float', null);
    if (!layerClone.fillOpacity && layer.fillOpacity) { layerClone.fillOpacity = layer.fillOpacity; }

    return layerClone;
  }

  processHandlebarsOnField(componentDefinition, contextParams, handlebarsContext, layerName, layerIndex, fieldName, layerField
    , layerFieldHandlebars, returnType) {
      // anchor = this.processHandlebarsOnVisualItem(layer.imageAnchor, layer.imageAnchorHandlebars, handlebarsContext, 'array', {
      //   handlebarsTemplateName: `${layer.name}_${layerIndex}_anchor`
      // });
      // if (!anchor && layer.imageAnchor) { anchor = layer.imageAnchor; }

    const field = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
    layerField, layerFieldHandlebars, handlebarsContext, returnType, null);

    return field;
  }

  processDynamicLayerData(layer, itemData, i, layerIndex, customData, vehicle) {
    const item = itemData.features[0];
    const pro = item.properties;
    const name = (pro.name ? pro.name : '');
    if (pro.labelDisplayZoom && (typeof pro.labelDisplayZoom === 'string' || pro.labelDisplayZoom instanceof String)) {
      pro.labelDisplayZoom = parseInt(pro.labelDisplayZoom);
    }
    // console.log('***** label = ' + pro.label);
    const label = {
      labelText : (typeof(pro.label) === 'string' && pro.label.trim().length > 0)
       ? pro.label : layer.labelText,
      labelTextAlign : (typeof(pro.labelTextAlign) === 'string' && pro.labelTextAlign.trim().length > 0)
       ? pro.labelTextAlign : layer.labelTextAlign,
      labelTextBaseline : (typeof(pro.labelTextBaseline) === 'string' && pro.labelTextBaseline.trim().length > 0)
       ? pro.labelTextBaseline : layer.labelTextBaseline,
      labelColor : (typeof(pro.labelColor) === 'string' && pro.labelColor.trim().length > 0)
       ? pro.labelColor : layer.labelColor,
      labelOutlineColor : (typeof(pro.labelOutlineColor) === 'string' && pro.labelOutlineColor.trim().length > 0)
       ? pro.labelOutlineColor : layer.labelOutlineColor,
      labelOutlineWidth : (typeof(pro.labelOutlineWidth) === 'number' && pro.labelOutlineWidth > 0)
       ? pro.labelOutlineWidth : layer.labelOutlineWidth,
      labelOffsetX : (typeof(pro.labelOffsetX) === 'number') ? pro.labelOffsetX : layer.labelOffsetX,
      labelOffsetY : (typeof(pro.labelOffsetY) === 'number') ? pro.labelOffsetY : layer.labelOffsetY,
      labelPlacement : (typeof(pro.labelPlacement) === 'string' && pro.labelPlacement.trim().length > 0)
       ? pro.labelPlacement : layer.labelPlacement,
      labelMaxAngle : (typeof(pro.labelMaxAngle) === 'number' && pro.labelMaxAngle >= 0 && pro.labelMaxAngle <= 360)
       ? pro.labelMaxAngle : layer.labelMaxAngle,
      labelOverflow : (typeof(pro.labelOverflow) === 'boolean') ? pro.labelOverflow : layer.labelOverflow,
      labelRotationWithView : (typeof(pro.labelRotationWithView) === 'boolean') ? pro.labelRotationWithView : layer.labelRotationWithView,
      labelRotation : (typeof(pro.labelRotation) === 'number' && pro.labelRotation >= 0 && pro.labelRotation <= 360)
       ? pro.labelRotation : layer.labelRotation,
      labelPadding : (Array.isArray(pro.labelPadding)) ? pro.labelPadding : layer.labelPadding,
      labelFont : (typeof(pro.labelFont) === 'string' && pro.labelFont.trim().length > 0)
       ? pro.labelFont : layer.labelFont,
      labelFontWeight : (typeof(pro.labelFontWeight) === 'string' && pro.labelFontWeight.trim().length > 0)
       ? pro.labelFontWeight : layer.labelFontWeight,
      labelFontSize : (typeof(pro.labelFontSize) === 'string' && pro.labelFontSize.trim().length > 0
       && pro.labelFontSize.indexOf('px') > -1) ? pro.labelFontSize : layer.labelFontSize,
      labelDisplayZoom:  (typeof(pro.labelDisplayZoom) === 'number' && pro.labelDisplayZoom > 0)
       ? pro.labelDisplayZoom : layer.labelDisplayZoom
    };


    let imageFileNo = '';
    if (layer.imageFileNo) {
      imageFileNo = layer.imageFileNo;
    }
    if (pro.image && Array.isArray(pro.image) && pro.image.length > 0) {
      imageFileNo = pro.image[0].fileNo;
    }

    const calRotate = this.calculateRotate(pro.bearing, pro.initialImageDirection
      , pro.initialImageWheelDirection); // (pro.bearing ? pro.bearing: 0);
    const rotation = calRotate.rotation;
    let scaleValue = 1;
    if (typeof(pro.imageScale) == 'number' && pro.imageScale > 0) {
      // need to calculate rotation
      scaleValue = pro.imageScale;
    }
    const scale = [scaleValue, scaleValue];
    if (calRotate.isFlip) {
      scale[0] = -scaleValue;
    }
    // console.log('**** rotation = ' + rotation + ', isFlip = ' + calRotate.isFlip);
    const tooltip = ((typeof(pro.tooltip) === 'string' && pro.tooltip.trim().length > 0) ? pro.tooltip: layer.tooltip);
    const dataId = pro.vehicleDocumentId;
    if (!dataId) {
      console.log(`*** invalid vehicleDocumentId: ${dataId}`);
    }
    const id = dataId + '_' + i + '_' + layerIndex;
    const url = 'form/' + dataId;

    const handlebarsContext: any = {
      results: customData,
      resultsCount: customData.length,
      resultsIndex: i,
      queryResultDocument: itemData,
    };
    if (vehicle) { handlebarsContext.vehicle = vehicle; }

    return {pro, handlebarsContext, label, item, id, name, tooltip, imageFileNo, url, dataId, rotation, scale};
  }

  processLayerRotation(layer, layerIndex, componentDefinition, contextParams, handlebarsContext) {
    let rotation = 0;
    if (layer.imageRotation) {
      rotation = layer.imageRotation;
    }
    if (layer.imageRotationHandlebars) {
      rotation = this.processHandlebarsOnVisualItem(componentDefinition, contextParams,
        layer.imageRotation, layer.imageRotationHandlebars, handlebarsContext, 'int', null);
      if (!rotation && layer.imageRotation) { rotation = layer.imageRotation; }
      if (!rotation) { rotation = 0; }
    }
    return rotation;
  }

  checkValidStyleString(obj) {
    if( !isString(obj) || obj.trim().length == 0 || obj.indexOf('{') > -1 || obj.indexOf('}') > -1) {
      return false;
    }
    return true;
  }

  checkStyleValue(assetSelection, isPrimary) {
    const styleInfo = cloneDeep(assetSelection);

    if(!this.checkValidStyleString(assetSelection.selectionImageFileNo)) {
      // console.log('invalid value of selectionImageFileNo: ' + assetSelection.selectionImageFileNo);
      styleInfo.selectionImageFileNo = (isPrimary ? SclMapConstantService.MAP_PRIMARY_ASSET : SclMapConstantService.MAP_SECONDARY_ASSET);
    }
    if(!Array.isArray(assetSelection.selectionImageAnchor)) {
      // console.log('invalid value of selectionImageAnchor: ' + assetSelection.selectionImageAnchor);
      styleInfo.selectionImageAnchor = [0.5, 0.5];
    }
    if(!isNumber(assetSelection.selectionImageRotation)) {
      // console.log('invalid value of selectionImageRotation: ' + assetSelection.selectionImageRotation);
      styleInfo.selectionImageRotation = 0;
    }
    if(!this.checkValidStyleString(assetSelection.selectionColor)) {
      // console.log('invalid value of selectionColor: ' + assetSelection.selectionColor);
      styleInfo.selectionColor = 'purple';
    }
    if(!this.checkValidStyleString(assetSelection.selectionFill)) {
      // console.log('invalid value of selectionFill: ' + assetSelection.selectionFill);
      styleInfo.selectionFill = 'purple';
    }
    if(!isNumber(assetSelection.selectionFillOpacity)) {
      // console.log('invalid value of selectionFillOpacity: ' + assetSelection.selectionFillOpacity);
      styleInfo.selectionFillOpacity = 1;
    }
    if(!this.checkValidStyleString(assetSelection.selectionLineCap)) {
      // console.log('invalid value of selectionColor: ' + assetSelection.selectionColor);
      styleInfo.selectionLineCap = null;
    }
    if(!Array.isArray(assetSelection.selectionLineDash)) {
      styleInfo.selectionLineDash = null;
    }
    if(!isNumber(assetSelection.selectionLineWidth)) {
      // console.log('invalid value of selectionImageRotation: ' + assetSelection.selectionImageRotation);
      styleInfo.selectionLineWidth = null;
    }
    return styleInfo;
  }

  toRadians(angleInDegrees) {
    return (angleInDegrees * Math.PI) / 180;
  }
  toDegrees(angleInRadians) {
    return (angleInRadians * 180) / Math.PI;
  }

  offset(c1, distance, earthRadius, bearing) {
    const lat1 = this.toRadians(c1[1]);
    const lon1 = this.toRadians(c1[0]);
    const dByR = distance / earthRadius;
    const lat = Math.asin(
      Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing)
    );
    const lon =
      lon1 +
      Math.atan2(
        Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1),
        Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat)
      );
    return [this.toDegrees(lon), this.toDegrees(lat)];
  }

  circleToPolygon(center, radius) {
    const n = 4; // there has 32 segments
    const earthRadius = 6378137;
    const bearing = 0;
    const direction = -1;

    const start = this.toRadians(bearing);
    const coordinates = [];
    for (let i = 0; i < n; i++) {
      coordinates.push(
        this.offset(
          center, radius, earthRadius, start + (direction * 2 * Math.PI * -i) / n
        )
      );
    }
    coordinates.push(coordinates[0]);

    return [coordinates];
  }


  calculateCircleCenterPoint(p1, p2) {
    const x1 = p1[0]; const y1 = p1[1];
    const x2 = p2[0]; const y2 = p2[1];

    const x = (x1 + x2) / 2;
    const y = (y1 + y2) / 2

    console.log(`center = [${x}, ${y}]`);

    return [x, y];
  }

  buildFilterObj(componentDefinition, geoJsonField) {
    const fil: any = {
      filter: componentDefinition.filter,
      layerDisplayOnly: componentDefinition.layerDisplayOnly,
      geoJsonField,
    };
    if (componentDefinition.color != null) {
      fil.color = componentDefinition.color;
    }
    if (componentDefinition.fill != null) {
      fil.fill = componentDefinition.fill;
    }
    if (componentDefinition.fillOpacity != null) {
      fil.fillOpacity = componentDefinition.fillOpacity;
    }
    if (componentDefinition.tooltips != null) {
      fil.tooltips = componentDefinition.tooltips;
    }
    if (componentDefinition.lineDash != null) {
      fil.lineDash = componentDefinition.lineDash;
    }
    if (componentDefinition.lineCap != null) {
      fil.lineCap = componentDefinition.lineCap;
    }
    if (componentDefinition.lineWidth != null) {
      fil.lineWidth = componentDefinition.lineWidth;
    }
    if (componentDefinition.imageAnchor != null) {
      fil.imageAnchor = componentDefinition.imageAnchor;
    }
    if (componentDefinition.imageFileNo != null) {
      fil.imageFileNo = componentDefinition.imageFileNo;
    }
    if (componentDefinition.labelText != null) {
      fil.labelText = componentDefinition.labelText;
    }
    if (componentDefinition.labelTextAlign != null) {
      fil.labelTextAlign = componentDefinition.labelTextAlign;
    }
    if (componentDefinition.labelTextBaseline != null) {
      fil.labelTextBaseline = componentDefinition.labelTextBaseline;
    }
    if (componentDefinition.labelColor != null) {
      fil.labelColor = componentDefinition.labelColor;
    }
    if (componentDefinition.labelOutlineColor != null) {
      fil.labelOutlineColor = componentDefinition.labelOutlineColor;
    }
    if (componentDefinition.labelOutlineWidth != null) {
      fil.labelOutlineWidth = componentDefinition.labelOutlineWidth;
    }
    if (componentDefinition.labelOffsetX != null) {
      fil.labelOffsetX = componentDefinition.labelOffsetX;
    }
    if (componentDefinition.labelOffsetY != null) {
      fil.labelOffsetY = componentDefinition.labelOffsetY;
    }
    if (componentDefinition.labelPlacement != null) {
      fil.labelPlacement = componentDefinition.labelPlacement;
    }
    if (componentDefinition.labelMaxAngle != null) {
      fil.labelMaxAngle = componentDefinition.labelMaxAngle;
    }
    if (componentDefinition.labelOverflow != null) {
      fil.labelOverflow = componentDefinition.labelOverflow;
    }
    if (componentDefinition.labelRotationWithView != null) {
      fil.labelRotationWithView = componentDefinition.labelRotationWithView;
    }
    if (componentDefinition.labelRotation != null) {
      fil.labelRotation = componentDefinition.labelRotation;
    }
    if (componentDefinition.labelPadding != null) {
      fil.labelPadding = componentDefinition.labelPadding;
    }
    if (componentDefinition.labelFont != null) {
      fil.labelFont = componentDefinition.labelFont;
    }
    if (componentDefinition.labelFontWeight != null) {
      fil.labelFontWeight = componentDefinition.labelFontWeight;
    }
    if (componentDefinition.labelFontSize != null) {
      fil.labelFontSize = componentDefinition.labelFontSize;
    }
    if (componentDefinition.labelDisplayZoom != null) {
      fil.labelDisplayZoom = componentDefinition.labelDisplayZoom;
    }
    if (componentDefinition.type != null) {
      fil.type = componentDefinition.type;
    }
    if (componentDefinition.noBoundingBox != null) {
      fil.noBoundingBox = componentDefinition.noBoundingBox;
    }
    return fil;
  }

  // **** calculate middle point of line string
  getPointByDistance(pnts, distance) {
    let cl = 0;
    let ol;
    let result;
    pnts.forEach((point, i, points) => {
      ol = cl;
      cl += i ? this.lineLen([points[i - 1], point]) : 0;
      if (distance <= cl && distance > ol) {
        const dd = distance - ol;
        result = this.pntOnLine([points[i - 1], point], dd);
      }
    });
    return result
  }
  pntOnLine(line, distance) {
    const t = distance / this.lineLen(line)
    const xt = (1 - t) * line[0][0] + (t * line[1][0]);
    const yt = (1 - t) * line[0][1] + (t * line[1][1]);
    return [xt, yt];
  }
  totalLen(pnts) {
    let tl = 0;
    pnts.forEach((point, i, points) => {
      tl += i ? this.lineLen([points[i - 1], point]) : 0;
    });
    return tl;
  }
  lineLen(line) {
    const xd = line[0][0] - line[1][0];
    const yd = line[0][1] - line[1][1];
    return Math.sqrt(xd * xd + yd * yd);
  }

  // format dimension
  formatDimension = function (value, dimensionsUnit, dimensionsPrecision) {
    if (dimensionsUnit === 'km') {
      value = value / 1000;
    } else if (dimensionsUnit === 'mm') {
      value = value * 1000;
    }
    const factor = Math.pow(10, dimensionsPrecision);
    const valuePrecision =  Math.round(value * factor) / factor;
    return `${valuePrecision} ${dimensionsUnit}`;
  }

  coordinateByDistanceAndBearing(lat, lon, distance, bearing) {
    const bearing_rad = (bearing * Math.PI) / 180;

    const EARTH_RADIUS = 6378137; // meters 6378.137;


    const init_lat = (lat * Math.PI) / 180;
    const init_lon = (lon * Math.PI) / 180;

    const final_lat = (180 / Math.PI) * (Math.asin( Math.sin(init_lat) *
     Math.cos(distance / EARTH_RADIUS) - Math.cos(init_lat) * Math.sin(distance / EARTH_RADIUS) *
     Math.cos(bearing_rad)));

    const final_lon = (180 / Math.PI) * (init_lon + Math.atan2(Math.sin(bearing_rad) *
     Math.sin(distance / EARTH_RADIUS) * Math.cos(init_lat),
     Math.cos(distance / EARTH_RADIUS) - Math.sin(init_lat) * Math.sin(final_lat)));

    return [final_lon, final_lat];
  }

  haversine(lonLat1, lonLat2) {
    const lon1 = lonLat1[0];
    const lat1 = lonLat1[1];
    const lon2 = lonLat2[0];
    const lat2 = lonLat2[1];

    const R = 6371; // km
    const x1 = lat2 - lat1;
    const dLat = this.toRadians(x1);
    const x2 = lon2 - lon1;
    const dLon = this.toRadians(x2)
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;

    return d;
  }

  traverseCoords(coordinates, coorDatas) {
    for (let i = 0; i < coordinates.length; i++) {
      if ( isFinite(coordinates[i][0]) && isFinite(coordinates[i][1]) ) {
        coorDatas.push([ coordinates[i][0], coordinates[i][1] ]);
      } else {

        this.traverseCoords(coordinates[i], coorDatas);
      }
    }
  }

  calculateCenter(polygon) {
    //// logger.info("this.calculateCenter2, polygon = " + JSON.stringify(polygon));
    const PI = 22 / 7;
    let X = 0;
    let Y = 0;
    let Z = 0;
    for (let i = 0; i < polygon.length; i++) {
      let lat1 = polygon[i][1];
      let lon1 = polygon[i][0];
      lat1 = lat1 * PI / 180;
      lon1 = lon1 * PI / 180;
      X += Math.cos(lat1) * Math.cos(lon1);
      Y += Math.cos(lat1) * Math.sin(lon1);
      Z += Math.sin(lat1);
    }
    let Lon = Math.atan2(Y, X);
    const Hyp = Math.sqrt(X * X + Y * Y);
    let Lat = Math.atan2(Z, Hyp);
    Lat = Lat * 180 / PI;
    Lon = Lon * 180 / PI;
    // return new google.maps.LatLng(Lat,Lon);

    return [Lon, Lat];
  }

  getCenterOfGeometry(coor, type) {
    if (type === MapDrawType.POINT) {
      return coor;
    } else {
      const coorDatas = [];
      this.traverseCoords(coor, coorDatas);
      if (type === MapDrawType.LINE_STRING) {
        const totalLength = this.totalLen(coorDatas);
        const midDistance = totalLength / 2;
        return this.getPointByDistance(coorDatas, midDistance);
      } else {
        return this.calculateCenter(coorDatas);
      }
    }
  }
  hasBoundingBox(layer) {
    let result = true;
    if (layer.noBoundingBox == true) {
      result = false;
    }
    return result;
  }

  checkDisableAddressEntry(componentDefinition, geocodeSearchService) {
    let currentProviderReverseIndex = 0;
    let currentProviderLookUpIndex = 0;
    let disableAddressEntry = false;
    if (typeof componentDefinition?.useGeocodeSearchService === 'string'
      && componentDefinition?.useGeocodeSearchService.trim().length > 0
      && componentDefinition?.useGeocodeSearchService.trim().toLowerCase() !== 'null'
      && geocodeSearchService.length > 0) {
      
      disableAddressEntry = true;
      for (let i = 0; i < geocodeSearchService.length; i++) {

        if (typeof geocodeSearchService[i].name !== 'string'
          || geocodeSearchService[i].name.trim().length === 0
        ) { continue; }

        if (geocodeSearchService[i].name.trim().toLowerCase() === 
        componentDefinition.useGeocodeSearchService.trim().toLowerCase()) {
          
          currentProviderReverseIndex = i;
          currentProviderLookUpIndex = i;
          disableAddressEntry = false;

          break;
        }
      }


    }

    return {disableAddressEntry, currentProviderReverseIndex, currentProviderLookUpIndex };
  }

  handleImageFileNo(imageFileNo) {
    const apiPrefix = '/api/getFile/';
    if (imageFileNo.startsWith(apiPrefix)) {
        // if the part after /api/getFile/ is a URL
        const valueAfterPrefix = imageFileNo.substring(apiPrefix.length);
        if (valueAfterPrefix.startsWith('http://') || valueAfterPrefix.startsWith('https://')) {
            // a URL after /api/getFile/, remove the prefix
            return valueAfterPrefix;
        } else {
            // not a URL, keep the full path with /api/getFile/
            return imageFileNo;
        }
    } else if (!imageFileNo.startsWith('http://') && !imageFileNo.startsWith('https://')) {
        // not a complete URL, add /api/getFile/
        return apiPrefix + imageFileNo;
    } else {
        //
        return imageFileNo;
    }
  }

  checkScopeValue(scopeValue, type) {
    if (scopeValue && scopeValue.features && scopeValue.features.length > 0
       && scopeValue.features[0].properties.type === type
        && typeof scopeValue.features[0].properties.country === 'undefined' &&
      typeof scopeValue.features[0].properties.iconImage === 'undefined'
        && typeof scopeValue.features[0].properties.iconSize === 'undefined' &&
      typeof scopeValue.features[0].properties.locationDescription === 'undefined'
        && typeof scopeValue.features[0].properties.postcode === 'undefined' &&
      typeof scopeValue.features[0].properties.street === 'undefined'
        && typeof scopeValue.features[0].properties.streetNo === 'undefined' &&
      typeof scopeValue.features[0].properties.suburb === 'undefined'
        && typeof scopeValue.features[0].properties.unitNo === 'undefined') {

        scopeValue.features[0].properties.unitNo = '';
        scopeValue.features[0].properties.streetNo = '';
        scopeValue.features[0].properties.street = '';
        scopeValue.features[0].properties.state = '';
        scopeValue.features[0].properties.suburb = '';
        scopeValue.features[0].properties.postcode = '';
        scopeValue.features[0].properties.locationDescription = '';
        scopeValue.features[0].properties.country = '';
        scopeValue.features[0].properties.iconImage = '';
        scopeValue.features[0].properties.iconSize = '';

        if (scopeValue.features[0].geometry && scopeValue.features[0].geometry.coordinates &&
          scopeValue.features[0].geometry.coordinates.length === 0) { delete scopeValue.features[0].geometry; }
        if (scopeValue.features[0].geometry) {
            if (!scopeValue.features[0].geometry.coordinates[0] || isNaN(scopeValue.features[0].geometry.coordinates[0]) ||
              isNaN(scopeValue.features[0].geometry.coordinates[1]) ) { delete scopeValue.features[0].geometry; }
        }
    }
    return scopeValue;
  }
}
